import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_HOME_VIDEOS(state,data) {
        state.homeVideos = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,homeVideos,list',data)
    },
    SET_HOME_VIDEO_STATUS(state,data) {
        state.homeVideoStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,homeVideos,homeVideoStatus',data)
    },
    SET_CURRENT_HOME_VIDEO(state,data) {
        state.currentHomeVideo = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,homeVideos,currentHomeVideo',data)
    },
    SET_FACTS(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,facts,list',data)
    },
    SET_CURRENT_FACT(state,data) {
        state.currentFact = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,facts,currentFact',data)
    },
    SET_TESTIMONIALS(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,testimonials,list',data)
    },
    SET_CURRENT_TESTIMONIAL(state,data) {
        state.currentTestimonial = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,testimonials,currentTestimonial',data)
    },
    SET_QUOTES(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,quotes,list',data)
    },
    SET_CURRENT_QUOTE(state,data) {
        state.currentQuote = data;
        //setStore('moduleName','Key',value)
        setStore('website','home,quotes,currentQuote',data)
    },
};
